module.exports = __webpack_public_path__ + "static/media/SNR.ee450b94.png";